module.exports = __webpack_public_path__ + "static/media/WinterCoat.e0ea3144.logo";